<style scoped lang="less">
    @import "../../../static/less/common";
    .card-img{
        padding-top: 30%;
        text-align: center;
        img{
            width: 28vh;
        }
        .card-text{
            font-size: 2.4vh;
            font-weight: bolder;
            line-height: 30px;
        }
    }
    .close{
        padding: 3vh 3vh;
        text-align: right;
        img{
            width: 3.5vh;
        }
    }
</style>

<template>
    <div class="backBox">
        <div class="close">
            <img src="../../assets/network-card/close.png" @click="closePage">
        </div>
        <div class="card-img">
            <img src="../../assets/network-card/notBL.png">
            <div class="card-text">
                网证下载设备与认证设备不匹配！<br>如需使用，请删除原有网证，并重新下载
            </div>
        </div>
        <div class="fixBottom">
            <van-button round color="#286EFF" class="next-btn" @click="toDeal">去下载</van-button>
        </div>
    </div>
</template>

<script>
import { Button } from "vant";
import { showGoBackBtn,goToClose ,closeWindow} from "@/util/jsbridge"

export default {
    name: "MismatchCard",
    components:{
        [Button.name]:Button,
    },
    data(){
        return{
            lists:[]
        }
    },
    created(){
        window.toDeal= this.toDeal;
        showGoBackBtn([{title:'去下载', duration:0, bgColor:'#518afd', methodName:'toDeal', methodParameter:''}]);
    },
    methods:{
        toDeal(){
            goToClose("https://app.robooot.com/auth/IndentityResultActivity",'','','IndentityResultActivity')
        },
        closePage(){
            closeWindow();
        }
    }
}
</script>
